import CantileverTheme from 'styles/cantileverTheme'

const palette = {
  ...CantileverTheme.colors,
  grayscale: {
    ...CantileverTheme.colors.grayscale,
    '650': 'rgba(34,34,34,1)',
  },
}

export type ForecastTheme = {
  pageBackground: string
  background1: string
  background2: string
  background2_5: string
  background3: string
  background4: string
  text1: string
  text2: string
  text3: string
  text4: string
  icon1: string
  icon2: string
  border: string
  border2: string
  textDisabled: string

  navSidebarBackground?: string
  pageBackground1?: string
  cardBackground?: string
  cardGroupBackground?: string
  cardDividerBackground?: string
  glassBackground?: string
  greenGlassBackground?: string
  redGlassBackground?: string
  blueGlassBackground?: string
  modalBackground?: string
  defaultText?: string
  secondaryText?: string
  tertiaryText?: string
  activeText?: string
  defaultButton?: string
  hoverButton?: string
  activeButton?: string
  defaultGhostButton?: string
  hoverGhostButton?: string
  activeGhostButton?: string
  boxShadow?: string

  danger?: string
  primary?: string
  warning?: string
  highlight?: string
}

export const ForecastDarkTheme: ForecastTheme = {
  pageBackground: palette.grayscale[600],
  background1: palette.grayscale[800],
  background2: palette.grayscale[700],
  background2_5: palette.grayscale[650],
  background3: palette.grayscale[600],
  background4: palette.grayscale[500],
  text1: palette.grayscale[100],
  text2: palette.grayscale[200],
  text3: palette.grayscale[300],
  text4: palette.grayscale[400],
  icon1: palette.grayscale[100],
  icon2: palette.grayscale[200],
  border: palette.grayscale[600],
  border2: palette.grayscale[600],
  textDisabled: palette.grayscale[400],
  navSidebarBackground: 'rgba(0, 0, 0, 1)',
  pageBackground1: 'rgba(38, 38, 38, 1)',
  cardBackground: 'rgba(64, 64, 64, 1)',
  cardGroupBackground: 'rgba(0, 0, 0, .12)',
  cardDividerBackground: 'rgba(0, 0, 0, .25)',
  glassBackground: 'rgba(102,102,102,0.5)',
  greenGlassBackground: 'rgba(132, 204, 22, 0.1)',
  modalBackground: `#6c6c6c`,
  redGlassBackground: 'rgba(255, 0, 0, 0.3)',
  blueGlassBackground: 'rgba(0, 100, 255, 0.2)',
  defaultText: 'rgba(229, 229, 229, 1)',
  secondaryText: 'rgba(163, 163, 163, 1)',
  tertiaryText: 'rgba(115, 115, 115, 1)',
  activeText: 'rgba(250, 250, 250, 1)',
  defaultButton: 'rgba(255, 255, 255, .1)',
  hoverButton: 'rgba(255, 255, 255, .15)',
  activeButton: 'rgba(255, 255, 255, .2)',
  defaultGhostButton: 'rgba(255, 255, 255, 0)',
  hoverGhostButton: 'rgba(255, 255, 255, 0.08)',
  activeGhostButton: 'rgba(255, 255, 255, .15)',
  boxShadow: 'rgba(0, 0, 0, 0.1)',
  danger: '#F92F06',
  primary: '#007BFF',
  warning: '#FAAD14',
  highlight: 'rgba(15, 143, 255, 0.65)', // Low opacity blue 400
}

export const ForecastLightTheme: ForecastTheme = {
  pageBackground: palette.grayscale[300],
  background1: palette.grayscale[100],
  background2: palette.grayscale[200],
  background2_5: palette.grayscale[250],
  background3: palette.grayscale[300],
  background4: palette.grayscale[400],
  text1: palette.grayscale[800],
  text2: palette.grayscale[700],
  text3: palette.grayscale[600],
  text4: palette.grayscale[500],
  icon1: palette.grayscale[800],
  icon2: palette.grayscale[700],
  border: palette.grayscale[700],
  border2: palette.grayscale[300],
  textDisabled: palette.grayscale[500],
  navSidebarBackground: 'rgba(229, 229, 229, 1)',
  pageBackground1: 'rgba(242, 242, 242, 1)',
  cardBackground: 'rgba(255, 255, 255, 1)',
  cardGroupBackground: 'rgba(0, 0, 0, .03)',
  cardDividerBackground: 'rgba(0, 0, 0, .1)',
  glassBackground: 'rgba(255,255,255,0.5)',
  defaultText: 'rgba(38, 38, 38, 1)',
  secondaryText: 'rgba(82, 82, 82, 1)',
  tertiaryText: 'rgba(115, 115, 115, 1)',
  activeText: 'rgba(10, 10, 10, 1)',
  defaultButton: 'rgba(0, 0, 0, .07)',
  hoverButton: 'rgba(0, 0, 0, .12)',
  activeButton: 'rgba(0, 0, 0, .17)',
  defaultGhostButton: 'rgba(0, 0, 0, 0)',
  hoverGhostButton: 'rgba(0, 0, 0, 0.03)',
  activeGhostButton: 'rgba(0, 0, 0, .07)',
  greenGlassBackground: 'rgba(132, 204, 22, 0.1)',
  redGlassBackground: 'rgba(255, 0, 0, 0.3)',
  blueGlassBackground: 'rgba(0, 100, 255, 0.2)',
  boxShadow: 'rgba(0, 0, 0, 0.1)',
  danger: '#F92F06',
  primary: '#007BFF',
  warning: '#FAAD14',
  highlight: 'rgba(15, 143, 255, 0.65)', // Low opacity blue 400
}

const barbie = {
  pink1: 'rgb(173, 62, 128)',
  pink2: 'rgb(195, 88, 151)',
  pink3: 'rgb(210, 113, 169)',
  pink4: 'rgb(232, 146, 198)',
  yellow1: 'rgb(244, 222, 163)',
  yellow2: 'rgb(222, 193, 115)',
  blue1: 'rgb(151, 204, 207)',
  blue2: 'rgb(124, 200, 204)',
}

export const ForecastBarbieTheme = {
  pageBackground: barbie.pink2,
  background1: barbie.pink1,
  background2: barbie.pink2,
  background2_5: barbie.pink3,
  background3: barbie.pink3,
  background4: barbie.pink4,
  text1: barbie.blue1,
  text2: barbie.blue2,
  text3: barbie.yellow1,
  text4: barbie.yellow2,
  icon1: barbie.blue1,
  icon2: barbie.yellow1,
  border: barbie.blue1,
  border2: barbie.yellow1,
  textDisabled: barbie.yellow2,
}

export const ForecastHotDogStandTheme = {
  pageBackground: 'rgb(125, 8, 6)',
  background1: 'rgb(209, 3, 0)',
  background2: 'rgb(171, 2, 0)',
  background2_5: 'rgb(150, 2, 0)',
  background3: 'rgb(125, 8, 6)',
  background4: 'rgb(100, 0, 0)',
  text1: 'rgb(240, 182, 22)',
  text2: 'rgb(196, 148, 14)',
  text3: 'rgb(171, 132, 22)',
  text4: 'rgb(171, 132, 22)',
  icon1: 'rgb(240, 182, 22)',
  icon2: 'rgb(196, 148, 14)',
  border: 'rgb(240, 182, 22)',
  border2: 'rgb(125, 8, 6)',
  textDisabled: 'rgb(171, 132, 22)',
}

const spooky = {
  orange1: 'rgb(255, 127, 36)',
  orange2: 'rgb(227, 110, 27)',
  orange3: 'rgb(184, 88, 20)',
  orange4: 'rgb(135, 64, 14)',

  gray500: 'rgb(105, 90, 79)',
  gray600: 'rgb(51, 46, 43)',
  gray650: 'rgb(36, 31, 28)',
  gray700: 'rgb(18, 14, 12)',
  gray800: 'rgb(10, 4, 1)',
}

export const ForecastSpookyTheme = {
  pageBackground: spooky.gray600,
  background1: spooky.gray800,
  background2: spooky.gray700,
  background2_5: spooky.gray650,
  background3: spooky.gray600,
  background4: spooky.gray500,
  text1: spooky.orange1,
  text2: spooky.orange2,
  text3: spooky.orange3,
  text4: spooky.orange4,
  icon1: spooky.orange1,
  icon2: spooky.orange2,
  border: spooky.orange1,
  border2: spooky.gray600,
  textDisabled: spooky.orange4,
}

const brat = {
  // should be (154, 205, 63) but forecast colors aren't rendering accurately
  // so this should match actual brat green ^
  green: 'rgb(139, 207, 2)',
  black: 'rgb(0, 0, 0)',
}

export const ForecastBratTheme = {
  pageBackground: brat.green,
  background1: brat.green,
  background2: brat.green,
  background2_5: brat.green,
  background3: brat.green,
  background4: brat.green,
  text1: brat.black,
  text2: brat.black,
  text3: brat.black,
  text4: brat.black,
  icon1: brat.black,
  icon2: brat.black,
  border: brat.black,
  border2: brat.black,
  textDisabled: brat.black,
}

const bratRemix = {
  greenDarker2: 'rgb(89, 133, 0)',
  greenDarker1: 'rgb(125, 190, 2)',
  actualBratGreen: 'rgb(139, 207, 2)',
  greenLighter1: 'rgb(154, 224, 13)',
  greenLighter2: 'rgb(181, 245, 54)',
  green4: 'rgb(89, 133, 0)',
  black1: 'rgb(0, 0, 0)',
  black2: 'rgb(20, 20, 20)',
  black3: 'rgb(40, 40, 40)',
  black4: 'rgb(60, 60, 60)',
}

export const ForecastBratRemixTheme = {
  pageBackground: bratRemix.actualBratGreen,
  background1: bratRemix.greenLighter2,
  background2: bratRemix.greenLighter1,
  background2_5: bratRemix.actualBratGreen,
  background3: bratRemix.greenDarker1,
  background4: bratRemix.greenDarker2,
  text1: bratRemix.black1,
  text2: bratRemix.black2,
  text3: bratRemix.black3,
  text4: bratRemix.black4,
  icon1: bratRemix.black1,
  icon2: bratRemix.black2,
  border: bratRemix.black1,
  border2: bratRemix.greenDarker1,
  textDisabled: bratRemix.black4,
}
